import { render, staticRenderFns } from "./EventHeader.vue?vue&type=template&id=88f81c78&scoped=true&"
import script from "./EventHeader.vue?vue&type=script&lang=js&"
export * from "./EventHeader.vue?vue&type=script&lang=js&"
import style0 from "./EventHeader.vue?vue&type=style&index=0&id=88f81c78&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88f81c78",
  null
  
)

export default component.exports